import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { IsAuthenticatedGuard } from './guards/is-authenticated.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/session/session.module').then(m => m.SessionModule),
  },
  {
    path: '',
    loadChildren: () => import('./views/public/public.module').then(m => m.PublicModule),
  },
  {
    path: 'painel',
    loadChildren: () => import('./views/private/private.module').then(m => m.PrivateModule),
    canMatch: [IsAuthenticatedGuard]
  },
  {
    path: 'print',
    loadChildren: () => import('./views/print/print.module').then(m => m.PrintModule),    
  },
  {
		path: '**',
		redirectTo: environment.home
	}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled'}),
    BrowserModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
